import { render, staticRenderFns } from "./UpdatePackage.vue?vue&type=template&id=6ac22fdb&scoped=true"
import script from "./UpdatePackage.vue?vue&type=script&lang=js"
export * from "./UpdatePackage.vue?vue&type=script&lang=js"
import style0 from "./UpdatePackage.vue?vue&type=style&index=0&id=6ac22fdb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac22fdb",
  null
  
)

export default component.exports